module.exports = __webpack_public_path__ + "img/hoel_portrett2.c68673c4.jpg";